import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDataTestId } from '../../../lib/props';
import { cn } from '../../../lib/utils';
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from '../../ui/dialog';
import { SpecraOverlayFooter } from '../lieutenants/overlay-footer';
import { SpecraOverlayHeader } from '../lieutenants/overlay-header';
const sizeClass = {
    sm: 'sm:max-w-md',
    md: 'sm:max-w-lg',
    lg: 'sm:max-w-2xl',
    xl: 'sm:max-w-4xl'
};
/** Controlled modal frame shared by entity, deviation, DSO, and diagram flows. */ export function SpecraOverlayDialog({ children, className, contentProps, contentRef, defaultOpen, description, footer, footerProps, bodyProps, bodyRef, focusableBody = true, onOpenChange, open, portalContainer, scrollBody = true, size = 'md', testId, title, trigger }) {
    return /*#__PURE__*/ _jsxs(Dialog, {
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        open: open,
        children: [
            trigger ? /*#__PURE__*/ _jsx(DialogTrigger, {
                asChild: true,
                children: trigger
            }) : null,
            /*#__PURE__*/ _jsxs(DialogContent, {
                ...contentProps,
                className: cn('flex max-h-[calc(100dvh-var(--component-overlay-edge-gap))] w-[calc(100%-var(--component-overlay-edge-gap))] flex-col gap-0 overflow-hidden bg-card p-0', sizeClass[size], contentProps?.className, className),
                "data-testid": testId ?? getDataTestId(contentProps),
                portalContainer: portalContainer,
                ref: contentRef,
                children: [
                    /*#__PURE__*/ _jsx(SpecraOverlayHeader, {
                        descriptionAsChild: true,
                        description: description ? /*#__PURE__*/ _jsx(DialogDescription, {
                            className: "text-[length:var(--fs-ui-caption)] text-muted-foreground",
                            children: description
                        }) : undefined,
                        title: /*#__PURE__*/ _jsx(DialogTitle, {
                            className: "font-display text-[length:var(--fs-ui-title)] font-medium leading-tight tracking-[var(--ls-display)] text-foreground",
                            children: title
                        }),
                        titleAsChild: true
                    }),
                    !description ? /*#__PURE__*/ _jsx(DialogDescription, {
                        className: "sr-only",
                        children: typeof title === 'string' ? `${title} dialog` : 'Dialog content'
                    }) : null,
                    /*#__PURE__*/ _jsx("div", {
                        ...bodyProps,
                        "aria-label": focusableBody ? bodyProps?.['aria-label'] ?? (typeof title === 'string' ? `${title} content` : 'Dialog content') : bodyProps?.['aria-label'],
                        className: cn(// flex-col so scrollBody=false hosts can pin a footer and scroll a flex-1 child.
                        'flex min-h-0 flex-1 flex-col px-4 py-3 sm:px-5 sm:py-4', scrollBody && 'overflow-y-auto', bodyProps?.className),
                        ref: bodyRef,
                        role: focusableBody ? bodyProps?.role ?? 'group' : bodyProps?.role,
                        tabIndex: focusableBody && scrollBody ? bodyProps?.tabIndex ?? 0 : bodyProps?.tabIndex,
                        children: children
                    }),
                    footerProps ? /*#__PURE__*/ _jsx(SpecraOverlayFooter, {
                        ...footerProps
                    }) : footer
                ]
            })
        ]
    });
}
